import React from 'react';
import { categories } from '../data/categories';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface ProgressBarProps {
  step: 'welcome' | 'organization' | 'assessment' | 'results';
  currentCategory: number;
}

const stages = [
  { id: 'welcome', label: 'Welcome' },
  ...categories.map(cat => ({ id: cat.id, label: cat.title.split(' ')[0] })),
  { id: 'organization', label: 'Details' },
  { id: 'results', label: 'Results' }
];

export default function ProgressBar({ step, currentCategory }: ProgressBarProps) {
  const currentIndex = step === 'assessment' ? currentCategory + 1 : 
    stages.findIndex(s => s.id === step);

  return (
    <div className="w-full relative">
      {/* Mobile Progress Bar */}
      <div className="md:hidden flex items-center justify-between gap-4 text-sm">
        <div className="flex-1 flex items-center justify-between bg-white/10 rounded-lg p-4">
          <div className="text-white/60">
            Stage {currentIndex + 1} of {stages.length}
          </div>
          <div className="font-medium text-white">
            {stages[currentIndex].label}
          </div>
        </div>
      </div>
      
      {/* Desktop Progress Bar */}
      <div className="hidden md:flex justify-between text-sm">
        {stages.map((stage, index) => (
          <div key={stage.id} className="relative">
            <div className={`pb-2 border-b-2 transition-all duration-300 min-w-[60px] text-center ${
              index === currentIndex
                ? 'text-white font-bold border-white'
                : 'text-white/60 border-transparent'
            }`}>
              {stage.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}